import { defineComponent as n, computed as o, openBlock as s, createElementBlock as i, createElementVNode as e, toDisplayString as d, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], v = /* @__PURE__ */ e("mask", { id: "1c42b5cf-bc12-438c-9e9b-f069732662c6" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#1c42b5cf-bc12-438c-9e9b-f069732662c6)" }, m = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#6da544",
  d: "M0 0h512v256H62z"
}, null, -1), k = /* @__PURE__ */ e("path", {
  fill: "#338af3",
  d: "M62 256h450v256H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M0 0v512l512-256z"
}, null, -1), x = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "M133.6 150.3c-49.1 0-89 40-89 89v33.4a89.1 89.1 0 0 0 178 0v-33.4c0-49-40-89-89-89zm55.6 122.4c0 24.9-16.4 46-39 53v-36.3l23.7-23.6-23.6-23.6v-19.6h-33.4V256l-23.6 23.6 23.6 23.6v22.6a55.7 55.7 0 0 1-39-53.1v-33.4a55.7 55.7 0 0 1 111.3 0z"
}, null, -1), w = { fill: "none" }, z = ["r"], B = /* @__PURE__ */ n({
  __name: "er",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const t = r, l = o(() => 512 + 2 * t.strokeWidth), c = o(() => -t.strokeWidth), a = o(() => 256 + t.strokeWidth / 2);
    return (b, y) => (s(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${c.value} ${c.value} ${l.value} ${l.value}`
    }, [
      v,
      e("g", u, [
        t.flagName ? (s(), i("title", m, d(t.flagName), 1)) : f("", !0),
        p,
        k,
        g,
        x
      ]),
      e("g", w, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: a.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, z)
      ])
    ], 8, h));
  }
});
export {
  B as default
};
//# sourceMappingURL=er-a0cad3a3.js.map
